import React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { HomePageCarouselState } from 'src/AppState/CmsState/HomePageCarouselState/HomePageCarouselState';
import { Input } from 'src/domains/layouts/shared/formComponents/input/Input';
import { Select } from 'src/domains/layouts/shared/formComponents/Select/components/Select';

interface PropsTypes {
    carouselPromoState: HomePageCarouselState
}

export const HomePageCarouselRedirectOptions = observer(({ carouselPromoState }: PropsTypes): React.ReactElement | null => {
    const { appCasinoState } = useAppStateContext();
    const { gamesOptionsForPromos } = appCasinoState.gameStore;
    const {
        btnLink,
        eventId,
        competitionId,
        gameId,
        actionTemplate,
        sport,
        sportListOptions,
    } = carouselPromoState;

    return (
        <>
            {actionTemplate.value === 'direct-link' ? (
                <Input
                    autoFocus
                    isEmpty={btnLink.value === ''}
                    label='Destination link'
                    dataTest='carousel-destination-link'
                    formInputState={btnLink} />
            ) : null}
            {actionTemplate.value === 'event-id' ? (
                <Input
                    autoFocus
                    isEmpty={eventId.value === ''}
                    label='Event id'
                    dataTest='carousel-event-id'
                    formInputState={eventId} />
            ) : null}
            {actionTemplate.value === 'competition-id' ? (
                <>
                    <Input
                        autoFocus
                        isEmpty={competitionId.value === ''}
                        label='Competition id'
                        dataTest='carousel-competition-id'
                        formInputState={competitionId} />

                    <Select defaultText='Select sport' selectOptions={sportListOptions} stateValue={sport} />
                </>
            ) : null}
            {actionTemplate.value === 'casino-game-id' && gamesOptionsForPromos.length > 0 ? (
                <Select dataTest='carousel-game-picker' defaultText='Select game' selectOptions={gamesOptionsForPromos} stateValue={gameId} />
            ) : null}
            {actionTemplate.value === 'sport' ? (
                <Select dataTest='carousel-sport-picker' defaultText='Select sport' selectOptions={sportListOptions} stateValue={sport} />
            ) : null}
        </>
    );
});
